import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { ListOrdered as OrderedList } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const DashboardTable = ({
    title = "",
    headers = [],
    rows = [],
    rowKey = "id",
    onRowClick,
}) => {
    const navigate = useNavigate();
    const hasData = rows && rows.length > 0;

    const dummyRows = Array.from({ length: 5 }).map((_, i) => {
        const obj = {};
        headers.forEach((h) => {
            obj[h.key] = "—";
        });
        return { id: `dummy-${i}`, ...obj };
    });

    const displayRows = hasData ? rows : dummyRows;
    return (
        <div className="relative w-full p-6 pb-3 dark:bg-gradient-to-r from-[#232142]/10 to-[#7E64A3]/10 bg-bgSecondary rounded-xl flex flex-col cursor-pointer text-gray-800 dark:text-white">
            <div className="flex items-center gap-3 pb-4">
                <OrderedList className="w-5 h-5 text-[#404040] dark:text-[#AEB9E1]" />
                <h2 className="text-[#404040] dark:text-[#AEB9E1] text-lg font-medium tracking-wide">{title}</h2>
            </div>
            <div className="relative">
            {!hasData && (
                <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none backdrop-blur-[2px]">
                    <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm px-4 py-2 rounded-md border border-gray-200 dark:border-gray-700/50 shadow-sm">
                        <span className="text-gray-500 dark:text-gray-400 text-sm font-medium">
                            No data to display
                        </span>
                    </div>
                </div>
            )}
            <Table
                className="w-full table-fixed"
                style={{
                    transform: "translateZ(0)",
                    contain: "layout",
                }}
            >
                {/* Header */}
                <Thead className={`border-t border-b border-[#5A4479D4] text-sm ${
                        !hasData
                            ? "text-gray-400 dark:text-gray-600"
                            : "dark:text-[#D8D8D8] text-[#808080]"
                    }`}>
                    <Tr>
                        {headers.map((header) => (
                            <Th key={header.key} className="text-left min-w-0 py-3 px-2">
                                {header.label}
                            </Th>
                        ))}
                    </Tr>
                </Thead>

                {/* Body */}
                <Tbody className="text-sm font-light text-[#404040] dark:text-[#CCCCCCE5]">
                    {rows && rows.length > 0 ? (
                        displayRows.map((row, index) => (
                            <Tr
                                key={row[rowKey] ?? index}
                                className={`${hasData ? "hover:bg-gray-700/10 cursor-pointer" : "opacity-50 pointer-events-none"}`}
                                onClick={() => {
                                    const interviewId = row.interview_id;
                                    if (interviewId) {
                                        navigate(`/org-admin/evaluationpage/${interviewId}`);
                                    }
                                    onRowClick?.(row);
                                }}
                            >
                                {headers.map((header) => {
                                    let cellValue = row[header.key];
                                    if (header.key === 'Score' && cellValue) {
                                        const num = parseFloat(String(cellValue).replace('%', ''));
                                        if (!isNaN(num)) {
                                            cellValue = `${Math.ceil(num)}%`;
                                        }
                                    }
                                    return (
                                        <Td
                                            key={header.key}
                                            className="text-left py-4 min-w-0 px-2"
                                        >
                                            <div className="truncate" title={cellValue}>
                                                {cellValue}
                                            </div>
                                        </Td>
                                    );
                                })}
                            </Tr>
                        ))
                    ) : (
                        <Tr>
                            <Td colSpan={headers.length} className="text-center py-10 text-gray-400">
                                {/* No Candidates Yet */}
                            </Td>
                        </Tr>
                    )}
                </Tbody>
            </Table>
            </div>
        </div>
    );
};

export default DashboardTable;